import { API } from '@utils/axios'

export async function fetchRecommendStoreList (params: any) {
  const response = await API.get('StoreRecommendation/stores', { params })
  return response.data
}

export async function fetchStoreRecommendationList (params: any) {
  const response = await API.get('StoreRecommendation/recommendations', { params })
  return response.data
}

export async function downloadStoreRecommendation (params: any) {
  const response = await API.get('StoreRecommendation/download', { params, responseType: 'blob' })
  return response.data
}
